import { MenuSectionModel } from './menu-section.model';

export class SideMenuModel {
    public sections: MenuSectionModel[] = [];
}
